<template>
    <div class="mv_cart_status" @click="cart()" v-if="$store.state.cart.items && $store.state.cart.items.length > 0">

            <div>
                <b>Il tuo ordine</b>
                <br>
                <small>{{$store.state.cart.items.reduce((t,x) => t + x.quantity,0)}} ELEMENTI</small>
            </div>
            
            <div style="text-align:right">
               {{total}}
            </div>

    </div>
</template>

<script>
import utils from '@/utils.js';
import CartVue from './Cart.vue'
export default {
  methods: {
    cart () {
      this.$root.$emit('popup',{component: CartVue})
    }
  },
  computed: {
      total () {
          return utils.euro(this.$store.state.cart.items.reduce((a,b) => a + (b.total || 0), 0))
      }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.mv_cart_status {
    display: grid;
    grid-template-columns: 3fr 1fr;
    background-color: white;
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: 80px;
    align-items: center;
    
    box-sizing:border-box;
    padding: 1em;
    padding-bottom: calc(1em + env(safe-area-inset-bottom));
    border-top: 1px solid #DDD;
    @media screen and (min-width: 769px) {
        width: 250px;
        bottom: 1em;
        right: 1em;
        left: auto;
        border: none;
        background: rgba(0,0,0,.8);
        color: white;
        border-radius: $radius;
        height: 64px;
        cursor: pointer;
    }
}
</style>